import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { DateTime } from 'luxon'


export default /*#__PURE__*/_defineComponent({
  __name: 'DateTimePicker',
  props: {
  label: {
    type: String,
    default: 'Date'
  },
  unsetText: {
    type: String,
    default: 'Not set'
  },
  value: {
    type: String,
    default: null
  },
  allowClear: {
    type: Boolean,
    default: true
  }
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props





const timezoneAbbr = computed<string>((): string => {
  const dt = DateTime.local()
  return dt.offsetNameShort || 'Local timezone'
})

const selectedDate = computed<string|null>({
  get: () => {
    if (!props.value) {
      return null
    }
    const rawDt = new Date(props.value)
    const year = rawDt.getFullYear()
    const month = (rawDt.getMonth() + 1).toString().padStart(2, '0')
    const day = rawDt.getDate().toString().padStart(2, '0')
    const hour = rawDt.getHours().toString().padStart(2, '0')
    const minute = rawDt.getMinutes().toString().padStart(2, '0')
    return `${year}-${month}-${day}T${hour}:${minute}`
  },
  set: (val: string|null) => {
    console.log('set', val)
    emit('input', val ? new Date(val).toISOString() : null)
  }
})


return { __sfc: true,props, emit, timezoneAbbr, selectedDate }
}

})